module.exports = __webpack_public_path__ + "static/media/Steel Manufacturers Association Logo.00fffc30.jpeg";